export { default } from './TeachingBubble';
